import { StyleSheet } from 'aphrodite';
import typography from 'defaults/typography';

//All color and font related changes here. The layout will be in .scss file

const getSkin = (theme) => {
    const skin = theme.globalProfiles.palette;
    const myTypography = typography(theme);

    return StyleSheet.create({
        title: {
            ...myTypography.subtitle,
            fontSize: '14px',
            color: skin.black,
            opacity: 0.8
        },
        name: {
            ...myTypography.body2,
            color: skin.black,
            opacity: 0.7
        },
        clickText: {
            ...myTypography.subtitle,
            fontSize: '14px',
            marginTop: '25px',
            color: skin.black,
            opacity: 0.3
        }
    });
}

export default getSkin;
